<template>
    <div class="row row-sezione">
        <div class="col-12">
            <div class="form-group">
                <select class="form-control" @change="this.onCityPicked">
                    <option value="">{{this.$t('seleziona_citta')}}</option>
                    <option v-for="city in this.consegneCitta" :value="city.id"
                            :selected="id_consegna_citta === city.id">
                        {{city.nome}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-12" v-if="this.city && this.city.zone.length">
            <div class="form-group">
                <select class="form-control" @change="this.onZonePicked">
                    <option value="">{{this.$t('seleziona_citta')}}</option>
                    <option v-for="zone in this.city.zone" :value="zone.id" :selected="id_consegna_zona === zone.id">
                        {{zone.cap}}
                        <span v-if="zone.nome"> / {{zone.nome}}</span>
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Lv1DeliveryManuale",
    props: ['consegneCitta', 'address'],
    data() {
        return {
            id_consegna_citta: null,
            id_consegna_zona: null
        };
    },
    created() {
        if (this.address) {
            this.id_consegna_citta = this.address.id_consegna_citta;
            this.id_consegna_zona = this.address.id_consegna_zona;
        }
    },
    computed: {
        city: function () {
            return this.consegneCitta.find((item) => {
                return item.id === this.id_consegna_citta;
            });
        },
        zona: function () {
            if (this.city) {
                return this.city.zone.find((item) => {
                    return item.id === this.id_consegna_zona;
                });
            }

            return null;
        }
    },
    methods: {
        onCityPicked: function (e) {
            this.id_consegna_zona = null;
            this.id_consegna_citta = e.target.value ? parseInt(e.target.value) : null;
            this.$emit('onCityPicked', this.city);
        },
        onZonePicked: function (e) {
            this.id_consegna_zona = e.target.value ? parseInt(e.target.value) : null;
            this.$emit('onZonePicked', this.zona);
        },
    }
}
</script>
